import { ButtonHTMLAttributes, RefObject } from 'react';
import classNames from 'classnames';

import { useTheme } from '@/theme';
import Icon, { IconTypes } from '@/components/Icon';
import Tooltip from '@/components/Tooltip';

import * as styles from './styles.module.scss';

export type IconButtonStyleTypes = 'round' | 'icon' | 'diamond';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    iconType: IconTypes;
    ariaLabel: string;
    buttonStyle: IconButtonStyleTypes;
    buttonRef?: RefObject<HTMLButtonElement>;
    tooltipContent?: string;
    tooltipIsVisible?: boolean;
    hasDot?: boolean;
}

export default function IconButton({
    iconType,
    ariaLabel,
    buttonStyle = 'round',
    className,
    buttonRef,
    tooltipContent,
    tooltipIsVisible,
    hasDot,
    ...props
}: IconButtonProps) {
    const theme = useTheme();
    return (
        <button
            className={classNames(styles.IconButton, className, {
                [styles['isRoundStyle']]: buttonStyle === 'round',
                [styles['isIconStyle']]: buttonStyle === 'icon',
                [styles['isDiamondStyle']]: buttonStyle === 'diamond',
                [styles['hasDot']]: hasDot,
            })}
            aria-label={ariaLabel}
            ref={buttonRef}
            {...props}
            style={
                buttonStyle === 'diamond' && theme.customJSON.diamondButtonMask
                    ? {
                          maskImage: `url("${theme.customJSON.diamondButtonMask}")`,
                      }
                    : {}
            }
        >
            <Icon type={iconType} size={24} />
            {tooltipContent && <Tooltip isVisible={tooltipIsVisible}>{tooltipContent}</Tooltip>}
        </button>
    );
}
